import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="py-12 bg-gray-50">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5">
          {/* Brand */}
          <div className="text-center sm:text-left">
            <Link
              to="/"
              onClick={scrollToTop}
              className="inline-block text-blue-600 hover:text-blue-700 font-bold text-xl mb-4"
            >
              DataBackfill
            </Link>
            <p className="text-gray-600 text-sm">
              Boutique AI & data delivery studio.
            </p>
          </div>

          {/* Services */}
          <div className="text-center sm:text-left">
            <h4 className="font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services#claude" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  Claude Implementation
                </Link>
              </li>
              <li>
                <Link to="/services#rag" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  RAG Systems
                </Link>
              </li>
              <li>
                <Link to="/services#agents" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  Agentic Workflows
                </Link>
              </li>
              <li>
                <Link to="/services#data" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  Data Infrastructure
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div className="text-center sm:text-left">
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  About
                </Link>
              </li>
              <li>
                <Link to="/team" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  Team
                </Link>
              </li>
              <li>
                <Link to="/work" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  Work
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div className="text-center sm:text-left">
            <h4 className="font-semibold mb-4">Resources</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="/blog"
                  className="text-gray-600 hover:text-blue-600"
                >
                  Blog
                </a>
              </li>
              <li>
                <Link to="/privacypolicy" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  Privacy
                </Link>
              </li>
              <li>
                <Link to="/terms" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  Terms
                </Link>
              </li>
            </ul>
          </div>

          {/* Use Cases */}
          <div className="text-center sm:text-left">
            <h4 className="font-semibold mb-4">Use Cases</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/use-cases/cmo" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  25 Use Cases for CMOs
                </Link>
              </li>
              <li>
                <Link to="/use-cases/marketing-ai" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  25 Marketing AI Use Cases
                </Link>
              </li>
              <li>
                <Link to="/use-cases/ai-bdr" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  25 AI BDR Use Cases
                </Link>
              </li>
              <li>
                <Link to="/use-cases/cfo" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  15 Use Cases for CFOs
                </Link>
              </li>
              <li>
                <Link to="/use-cases/customer-support" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  20 AI Customer Support Use Cases
                </Link>
              </li>
              <li>
                <Link to="/use-cases/revops" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  12 RevOps AI Use Cases
                </Link>
              </li>
              <li>
                <Link to="/use-cases/hr" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  10 AI Use Cases for HR Teams
                </Link>
              </li>
              <li>
                <Link to="/use-cases/data-teams" onClick={scrollToTop} className="text-gray-600 hover:text-blue-600">
                  18 Use Cases for Data Teams
                </Link>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-gray-200 mt-12 pt-8 text-center text-gray-600 text-sm">
          <p>© {new Date().getFullYear()} DataBackfill. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
